import React from "react";
import styles from "../style/layouts/chatlayout.module.css";

const ChatLayout = ({ sidebar, chatPannel, mainContent }) => {
  return (
    <div className={styles.ChatPageContainer}>
      <div className={styles.ChatPageContent}>
        {sidebar}
        {chatPannel}
        {mainContent}
      </div>
    </div>
  );
};

export default ChatLayout;
